<template>
  <div class="page-cert">
    <el-card shadow="never">
      <div class="toolbar">
        <div class="toolbar-filter">
          <span class="toolbar-label">筛选</span>
          <el-input
            v-model.trim="filterQueryCode"
            size="small"
            clearable
            placeholder="查询码"
            class="toolbar-input toolbar-query-code"
            @keyup.enter.native="search"
          />
          <el-input
            v-model.trim="filterProductName"
            size="small"
            clearable
            placeholder="签名名称模糊查询"
            class="toolbar-input"
            @keyup.enter.native="search"
          />
          <el-select
            v-model="filterAuditStatus"
            size="small"
            clearable
            placeholder="审核状态"
            class="toolbar-select"
          >
            <el-option label="通过" value="PASS" />
            <el-option label="不通过" value="FAIL" />
            <el-option label="待审核" value="PENDING" />
          </el-select>
          <div class="toolbar-filter-actions">
            <el-button type="primary" size="small" icon="el-icon-search" @click="search">查询</el-button>
            <el-button size="small" icon="el-icon-refresh-left" @click="resetFilters">重置</el-button>
          </div>
        </div>

        <div class="toolbar-actions">
          <div class="toolbar-actions-left">
            <el-button type="primary" size="small" icon="el-icon-plus" @click="openCreate">新建证书</el-button>
            <span class="toolbar-divider" />
            <el-button size="small" icon="el-icon-upload2" @click="openImportDialog">批量导入</el-button>
            <el-button size="small" icon="el-icon-download" :loading="exporting" @click="exportExcel">导出 Excel</el-button>
            <el-button
              size="small"
              icon="el-icon-picture-outline"
              :loading="allQrDownloading"
              @click="downloadAllQr"
            >下载全部二维码</el-button>
          </div>
          <div class="toolbar-actions-right">
            <span v-if="selectedRows.length" class="toolbar-selected-tip">已选 {{ selectedRows.length }} 条</span>
            <span v-else class="toolbar-selected-tip is-muted">勾选表格行后可批量操作</span>
            <el-button
              size="small"
              icon="el-icon-picture-outline"
              :disabled="selectedRows.length === 0"
              :loading="batchQrDownloading"
              @click="batchDownloadQr"
            >下载二维码</el-button>
            <el-button
              type="danger"
              plain
              size="small"
              icon="el-icon-delete"
              :disabled="selectedRows.length === 0"
              :loading="batchDeleting"
              @click="batchRemove"
            >批量删除</el-button>
          </div>
        </div>
      </div>
      <el-table
        ref="certTable"
        v-loading="loading"
        :data="list"
        border
        stripe
        size="small"
        row-key="id"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="42" fixed="left" reserve-selection />
        <el-table-column prop="id" label="ID" width="60" />
        <el-table-column prop="queryCode" label="查询码" min-width="90" show-overflow-tooltip />
        <el-table-column prop="orgName" label="鉴别组织" min-width="90" show-overflow-tooltip />
        <el-table-column prop="artistName" label="鉴别艺人" min-width="90" show-overflow-tooltip />
        <el-table-column prop="productName" label="签名产品" min-width="120" show-overflow-tooltip />
        <el-table-column prop="securityNo" label="防伪编号" width="110" />
        <el-table-column prop="rating" label="评级评分" width="80" />
        <el-table-column prop="scanCount" label="被查询次数" width="96" align="center" />
        <el-table-column label="二维码" width="72" align="center">
          <template slot-scope="scope">
            <div
              v-if="scope.row.queryCode"
              class="qr-cell"
              @click="openQrDialog(scope.row)"
            >
              <img
                v-if="qrCache[scope.row.id]"
                :src="qrCache[scope.row.id]"
                class="qr-thumb"
                alt="证书查询二维码"
              />
              <span v-else class="qr-thumb-placeholder">…</span>
            </div>
            <span v-else>—</span>
          </template>
        </el-table-column>
        <el-table-column label="审核状态" width="88">
          <template slot-scope="scope">
            {{ auditLabel(scope.row.auditStatus) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="openEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="mini" @click="openScanDialog(scope.row)">修改查询次数</el-button>
            <el-button type="text" size="mini" style="color: #f56c6c" @click="remove(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pager"
        background
        small
        layout="total, sizes, prev, pager, next"
        :total="total"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="size"
        :current-page.sync="page"
        @size-change="handleSizeChange"
        @current-change="fetchList"
      />
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="520px" append-to-body @closed="resetForm">
      <el-form ref="formRef" :model="form" :rules="formRules" label-width="110px" size="small">
        <el-form-item label="查询码" prop="queryCode">
          <el-input v-model.trim="form.queryCode" maxlength="64" show-word-limit placeholder="前台用户输入此码查询" />
        </el-form-item>
        <el-form-item label="鉴别组织" prop="orgName">
          <el-input v-model.trim="form.orgName" maxlength="128" />
        </el-form-item>
        <el-form-item label="鉴别艺人" prop="artistId">
          <el-select
            v-model="form.artistId"
            filterable
            placeholder="请选择艺人"
            style="width: 100%"
            :loading="artistLoading"
          >
            <el-option
              v-for="opt in artistOptions"
              :key="opt.id"
              :label="opt.name"
              :value="opt.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="签名产品" prop="productName">
          <el-input v-model.trim="form.productName" maxlength="512" />
        </el-form-item>
        <el-form-item label="防伪编号" prop="securityNo">
          <el-input v-model.trim="form.securityNo" maxlength="16" placeholder="建议 10 位数字" />
        </el-form-item>
        <el-form-item label="评级评分" prop="rating">
          <el-input v-model.trim="form.rating" maxlength="64" />
        </el-form-item>
        <el-form-item label="首次查询文案" prop="queryResultFirst">
          <el-input v-model="form.queryResultFirst" type="textarea" :rows="2" maxlength="800" show-word-limit />
        </el-form-item>
        <el-form-item label="非首次查询文案" prop="queryResultRepeat">
          <el-input v-model="form.queryResultRepeat" type="textarea" :rows="2" maxlength="800" show-word-limit />
        </el-form-item>
        <el-form-item label="审核状态" prop="auditStatus">
          <el-select v-model="form.auditStatus" placeholder="请选择" style="width: 100%">
            <el-option label="通过" value="PASS" />
            <el-option label="不通过" value="FAIL" />
            <el-option label="待审核" value="PENDING" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="saving" @click="submit">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="证书查询二维码"
      :visible.sync="qrDialogVisible"
      width="420px"
      append-to-body
      @closed="onQrDialogClosed"
    >
      <div v-if="qrDialogRow" class="qr-dialog-body">
        <p class="qr-dialog-tip">扫码打开证书查询页并展示该证书（查询码：{{ qrDialogRow.queryCode }}）</p>
        <div class="qr-dialog-img-wrap">
          <img v-if="qrDialogDataUrl" :src="qrDialogDataUrl" class="qr-dialog-img" alt="证书查询二维码" />
          <span v-else class="qr-dialog-loading">正在生成二维码…</span>
        </div>
        <el-input :value="qrDialogLink" readonly size="small" class="qr-dialog-link">
          <el-button slot="append" size="small" @click="copyQrLink">复制链接</el-button>
        </el-input>
      </div>
      <div slot="footer">
        <el-button size="small" @click="qrDialogVisible = false">关闭</el-button>
        <el-button type="primary" size="small" :disabled="!qrDialogDataUrl" @click="downloadQrImage">下载二维码</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="progressDialogTitle"
      :visible.sync="exportProgressVisible"
      width="480px"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <p class="export-progress-tip">{{ exportProgressText }}</p>
      <el-progress
        :percentage="exportProgressPercent"
        :stroke-width="20"
        :status="exportProgressPercent >= 100 ? 'success' : undefined"
        text-inside
      />
      <p v-if="progressDialogHint" class="export-progress-sub">{{ progressDialogHint }}</p>
    </el-dialog>

    <el-dialog title="修改查询次数" :visible.sync="scanDialogVisible" width="400px" append-to-body @closed="onScanDialogClosed">
      <div class="scan-dialog-body">
        <p v-if="scanRow" class="scan-tip">查询码：{{ scanRow.queryCode }}，当前次数：{{ scanRow.scanCount != null ? scanRow.scanCount : 0 }}</p>
        <el-radio-group v-model="scanMode" size="small" class="scan-mode">
          <el-radio label="reset">重置为 0</el-radio>
          <el-radio label="custom">指定次数</el-radio>
        </el-radio-group>
        <div v-if="scanMode === 'custom'" class="scan-custom">
          <span class="label">次数</span>
          <el-input-number v-model="scanCustomValue" size="small" :min="0" :max="999999999" :step="1" controls-position="right" />
        </div>
      </div>
      <div slot="footer">
        <el-button size="small" @click="scanDialogVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="scanSaving" @click="confirmScan">确定</el-button>
      </div>
    </el-dialog>

    <!-- 批量导入：上传 → 复检编辑 → 确认新增 -->
    <el-dialog
      :visible.sync="importVisible"
      :width="importStep === 1 ? '92%' : '560px'"
      top="8vh"
      custom-class="import-dialog"
      append-to-body
      :close-on-click-modal="false"
      @closed="resetImportDialog"
    >
      <div slot="title" class="import-dialog-title">
        <span class="import-dialog-title-main">批量导入证书</span>
        <span class="import-dialog-title-sub">按模板填写后上传，复检通过即可入库</span>
      </div>

      <div class="import-steps">
        <div
          v-for="(s, idx) in ['上传文件', '复检修改', '完成']"
          :key="s"
          class="import-step-item"
          :class="{
            'is-active': importStep === idx,
            'is-done': importStep > idx
          }"
        >
          <span class="import-step-num">{{ idx + 1 }}</span>
          <span class="import-step-text">{{ s }}</span>
          <span v-if="idx < 2" class="import-step-line" />
        </div>
      </div>

      <div v-if="importStep === 0" class="import-step-upload">
        <div class="import-guide">
          <p>
            表头需为 <em>名字、评分、编号、产品</em>。
            编号将同时作为查询码与防伪编号，可在下一步修改。
          </p>
          <el-button
            type="text"
            size="small"
            icon="el-icon-download"
            class="import-template-btn"
            :loading="importTemplateLoading"
            @click="downloadImportTemplate"
          >下载导入模板</el-button>
        </div>
        <el-upload
          class="import-uploader"
          drag
          action=""
          :auto-upload="false"
          :limit="1"
          accept=".xlsx,.xls"
          :file-list="importFileList"
          :on-change="onImportFileChange"
          :on-remove="onImportFileRemove"
        >
          <i class="el-icon-upload2 import-upload-icon" />
          <div class="el-upload__text">拖拽文件到此处，或 <em>点击选择</em></div>
          <div slot="tip" class="el-upload__tip">支持 .xlsx / .xls，单次最多 2000 行</div>
        </el-upload>
      </div>

      <div v-else-if="importStep === 1" class="import-step-review">
        <div
          class="import-summary"
          :class="importPreview.duplicateCount || importPreview.errorCount ? 'is-warn' : 'is-ok'"
        >
          {{ importSummaryText }}
        </div>
        <div
          v-if="importNewArtists.length"
          class="import-new-artists"
        >
          <div class="import-new-artists-title">
            <i class="el-icon-warning-outline" />
            以下 {{ importNewArtists.length }} 位艺人不在库中，确认导入时将自动新建（已去重）：
          </div>
          <div class="import-new-artists-tags">
            <el-tag
              v-for="name in importNewArtists"
              :key="name"
              type="warning"
              size="mini"
              effect="plain"
              class="import-new-artist-tag"
            >{{ name }}</el-tag>
          </div>
        </div>
        <div class="import-review-toolbar">
          <el-checkbox v-model="importSkipDuplicates">跳过重复行，导入其余有效数据</el-checkbox>
          <el-button type="text" size="small" @click="removeInvalidImportRows">移除无效/重复行</el-button>
          <span class="import-hint">可在表格中直接修改；不在库中的艺人将自动新建</span>
        </div>
        <el-table
          :data="importRows"
          border
          stripe
          max-height="480"
          size="mini"
          class="import-table"
          style="width: 100%"
          :row-class-name="importRowClassName"
        >
          <el-table-column prop="excelRow" label="行号" width="64" align="center" fixed />
          <el-table-column label="状态" width="90" fixed>
            <template slot-scope="scope">
              <el-tag v-if="scope.row.hasError" type="danger" size="mini" effect="plain">错误</el-tag>
              <el-tag v-else-if="scope.row.duplicate" type="warning" size="mini" effect="plain">重复</el-tag>
              <el-tag v-else-if="scope.row.artistWillCreate" type="warning" size="mini" effect="plain">将新建艺人</el-tag>
              <el-tag v-else type="success" size="mini" effect="plain">可导入</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="提示" min-width="180" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ (scope.row.messages || []).join('；') || '—' }}
            </template>
          </el-table-column>
          <el-table-column label="名字/艺人" min-width="180">
            <template slot-scope="scope">
              <div class="import-artist-cell">
                <el-input
                  v-model.trim="scope.row.artistName"
                  size="mini"
                  maxlength="128"
                  placeholder="艺人名字"
                  @change="onImportArtistNameChange(scope.row)"
                />
                <el-tag
                  v-if="scope.row.artistWillCreate && !scope.row.hasError"
                  type="warning"
                  size="mini"
                  effect="plain"
                >将自动新建</el-tag>
                <el-tag
                  v-else-if="scope.row.artistId && !scope.row.hasError"
                  type="success"
                  size="mini"
                  effect="plain"
                >已在库中</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="评分" width="90">
            <template slot-scope="scope">
              <el-input v-model.trim="scope.row.rating" size="mini" maxlength="64" />
            </template>
          </el-table-column>
          <el-table-column label="查询码" min-width="130">
            <template slot-scope="scope">
              <el-input v-model.trim="scope.row.queryCode" size="mini" maxlength="64" @change="recheckImportRowLocal(scope.row)" />
            </template>
          </el-table-column>
          <el-table-column label="防伪编号" min-width="120">
            <template slot-scope="scope">
              <el-input v-model.trim="scope.row.securityNo" size="mini" maxlength="16" />
            </template>
          </el-table-column>
          <el-table-column label="产品" min-width="160">
            <template slot-scope="scope">
              <el-input v-model.trim="scope.row.productName" size="mini" maxlength="512" />
            </template>
          </el-table-column>
          <el-table-column label="鉴别组织" width="100">
            <template slot-scope="scope">
              <el-input v-model.trim="scope.row.orgName" size="mini" maxlength="128" />
            </template>
          </el-table-column>
          <el-table-column label="操作" width="70" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="mini" style="color:#f56c6c" @click="removeImportRow(scope.$index)">移除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div v-else class="import-step-result">
        <div
          class="import-result-banner"
          :class="importConfirmResult.failedCount ? 'is-warn' : 'is-ok'"
        >
          <i :class="importConfirmResult.failedCount ? 'el-icon-warning-outline' : 'el-icon-circle-check'" />
          <h3>{{ importResultTitle }}</h3>
          <p>{{ (importConfirmResult.messages || []).join(' ') }}</p>
        </div>
        <el-table
          v-if="importConfirmResult.details && importConfirmResult.details.length"
          :data="importConfirmResult.details"
          border
          size="mini"
          max-height="320"
          class="import-table"
          style="margin-top: 16px"
        >
          <el-table-column prop="excelRow" label="行号" width="70" />
          <el-table-column prop="queryCode" label="查询码" min-width="120" />
          <el-table-column label="结果" width="90">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status === 'SUCCESS'" type="success" size="mini" effect="plain">成功</el-tag>
              <el-tag v-else-if="scope.row.status === 'SKIPPED'" type="info" size="mini" effect="plain">跳过</el-tag>
              <el-tag v-else type="danger" size="mini" effect="plain">失败</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="message" label="说明" min-width="200" show-overflow-tooltip />
        </el-table>
      </div>

      <div slot="footer" class="import-dialog-footer">
        <el-button v-if="importStep === 0" size="small" @click="importVisible = false">取消</el-button>
        <el-button
          v-if="importStep === 0"
          type="primary"
          size="small"
          :loading="importParsing"
          :disabled="!importSelectedFile"
          @click="parseImportFile"
        >解析并复检</el-button>
        <el-button v-if="importStep === 1" size="small" @click="importStep = 0">上一步</el-button>
        <el-button
          v-if="importStep === 1"
          type="primary"
          size="small"
          :loading="importConfirming"
          :disabled="!importRows.length"
          @click="confirmImport"
        >确认批量新增</el-button>
        <el-button v-if="importStep === 2" type="primary" size="small" @click="closeImportAndRefresh">完成</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  certPageApi,
  certCreateApi,
  certUpdateApi,
  certDeleteApi,
  certUpdateScanCountApi,
  certExportApi,
  certBatchQrDownloadApi,
  certDownloadAllQrApi,
  certBatchDeleteApi,
  certImportTemplateApi,
  certImportPreviewApi,
  certImportConfirmApi
} from '../api/certificate'
import { artistOptionsApi } from '../api/artist'
import { fetchCertQr } from '../utils/certQr'

const emptyForm = () => ({
  id: null,
  queryCode: '',
  orgName: 'ACAA',
  artistId: null,
  productName: '',
  securityNo: '',
  rating: '',
  queryResultFirst: '首次查询，本签名为亲笔签名。',
  queryResultRepeat: '非首次查询，本签名为亲笔签名。',
  auditStatus: 'PASS'
})

export default {
  name: 'CertificateManage',
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      page: 1,
      size: 10,
      filterQueryCode: '',
      filterProductName: '',
      filterAuditStatus: null,
      exporting: false,
      batchQrDownloading: false,
      allQrDownloading: false,
      batchDeleting: false,
      selectedRows: [],
      progressDialogTitle: '正在导出 Excel',
      progressDialogHint: '',
      exportProgressVisible: false,
      exportProgressPercent: 0,
      exportProgressText: '',
      exportProgressTimer: null,
      dialogVisible: false,
      dialogTitle: '',
      saving: false,
      form: emptyForm(),
      formRules: {
        queryCode: [{ required: true, message: '必填', trigger: 'blur' }],
        orgName: [{ required: true, message: '必填', trigger: 'blur' }],
        artistId: [{ required: true, message: '请选择艺人', trigger: 'change' }],
        productName: [{ required: true, message: '必填', trigger: 'blur' }],
        securityNo: [{ required: true, message: '必填', trigger: 'blur' }]
      },
      artistOptions: [],
      artistLoading: false,
      scanDialogVisible: false,
      scanSaving: false,
      scanRow: null,
      scanMode: 'reset',
      scanCustomValue: 0,
      qrCache: {},
      qrDialogVisible: false,
      qrDialogRow: null,
      qrDialogDataUrl: '',
      qrDialogLink: '',
      // 批量导入
      importVisible: false,
      importStep: 0,
      importFileList: [],
      importSelectedFile: null,
      importParsing: false,
      importConfirming: false,
      importTemplateLoading: false,
      importSkipDuplicates: true,
      importPreview: {
        total: 0,
        validCount: 0,
        duplicateCount: 0,
        errorCount: 0
      },
      importNewArtists: [],
      importRows: [],
      importConfirmResult: {
        total: 0,
        successCount: 0,
        skippedCount: 0,
        failedCount: 0,
        messages: [],
        details: []
      }
    }
  },
  computed: {
    importSummaryText() {
      const p = this.importPreview || {}
      const artistTip = this.importNewArtists.length
        ? `，将新建艺人 ${this.importNewArtists.length} 位`
        : ''
      return `共 ${p.total || this.importRows.length} 行：可导入 ${p.validCount || 0}，重复 ${p.duplicateCount || 0}，错误 ${p.errorCount || 0}${artistTip}`
    },
    importResultTitle() {
      const r = this.importConfirmResult || {}
      const artistTip = r.artistCreatedCount ? `，新建艺人 ${r.artistCreatedCount}` : ''
      return `成功 ${r.successCount || 0}，跳过 ${r.skippedCount || 0}，失败 ${r.failedCount || 0}${artistTip}`
    }
  },
  mounted() {
    this.loadArtistOptions()
    this.fetchList()
  },
  beforeDestroy() {
    this.stopExportProgressSimulation()
  },
  methods: {
    async loadArtistOptions() {
      this.artistLoading = true
      try {
        const res = await artistOptionsApi()
        this.artistOptions = res.data || []
      } catch (e) {
        this.$message.error(e.message || '加载艺人列表失败')
        this.artistOptions = []
      } finally {
        this.artistLoading = false
      }
    },
    auditLabel(v) {
      if (v === 'PASS') return '通过'
      if (v === 'FAIL') return '不通过'
      if (v === 'PENDING') return '待审核'
      return v || '—'
    },
    search() {
      this.page = 1
      this.fetchList()
    },
    resetFilters() {
      this.filterQueryCode = ''
      this.filterProductName = ''
      this.filterAuditStatus = null
      this.page = 1
      this.fetchList()
    },
    buildFilterParams() {
      const params = {}
      const q = (this.filterQueryCode || '').trim()
      if (q) params.queryCode = q
      const kw = (this.filterProductName || '').trim()
      if (kw) params.productName = kw
      if (this.filterAuditStatus) params.auditStatus = this.filterAuditStatus
      return params
    },
    setExportProgress(percent, text) {
      const p = Math.min(100, Math.max(0, Math.round(percent)))
      if (p > this.exportProgressPercent) {
        this.exportProgressPercent = p
      }
      if (text) {
        this.exportProgressText = text
      }
    },
    startExportProgressSimulation() {
      this.stopExportProgressSimulation()
      let p = 5
      this.exportProgressPercent = p
      this.exportProgressText = '正在查询数据并生成 Excel（含二维码）…'
      this.exportProgressTimer = setInterval(() => {
        if (p < 88) {
          const step = p < 35 ? 4 : p < 65 ? 2 : 1
          p = Math.min(88, p + step)
          this.exportProgressPercent = p
        }
      }, 400)
    },
    stopExportProgressSimulation() {
      if (this.exportProgressTimer) {
        clearInterval(this.exportProgressTimer)
        this.exportProgressTimer = null
      }
    },
    exportDelay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    handleSelectionChange(rows) {
      this.selectedRows = rows || []
    },
    clearTableSelection() {
      this.selectedRows = []
      this.$nextTick(() => {
        if (this.$refs.certTable) {
          this.$refs.certTable.clearSelection()
        }
      })
    },
    getSelectedIds() {
      if (!this.selectedRows.length) return []
      return this.selectedRows.map(r => r.id).filter(id => id != null)
    },
    batchRemove() {
      const ids = this.getSelectedIds()
      if (!ids.length) {
        this.$message.warning('请先勾选要删除的证书')
        return
      }
      if (ids.length > 200) {
        this.$message.warning('单次最多删除 200 条，请减少选择数量')
        return
      }
      const preview = this.selectedRows
        .slice(0, 5)
        .map(r => r.queryCode)
        .filter(Boolean)
        .join('、')
      const more = ids.length > 5 ? ` 等共 ${ids.length} 条` : ''
      this.$confirm(
        `确定删除所选证书吗？${preview ? '\n查询码：' + preview + more : '\n共 ' + ids.length + ' 条'}\n删除后不可恢复。`,
        '批量删除确认',
        { type: 'warning', confirmButtonText: '确定删除', cancelButtonText: '取消' }
      )
        .then(async () => {
          this.batchDeleting = true
          try {
            const res = await certBatchDeleteApi(ids)
            const deleted = (res.data && res.data.deleted) != null ? res.data.deleted : ids.length
            this.$message.success(`已删除 ${deleted} 条`)
            this.clearTableSelection()
            this.fetchList()
          } catch (e) {
            this.$message.error(e.message || '批量删除失败')
          } finally {
            this.batchDeleting = false
          }
        })
        .catch(() => {})
    },
    parseBlobFilename(res, defaultName) {
      let filename = defaultName
      const cd = res.headers && res.headers['content-disposition']
      if (cd) {
        const star = /filename\*=UTF-8''([^;]+)/i.exec(cd)
        if (star) {
          filename = decodeURIComponent(star[1])
        } else {
          const plain = /filename="?([^";]+)"?/i.exec(cd)
          if (plain) filename = plain[1]
        }
      }
      return filename
    },
    async saveBlobResponse(res, defaultFilename, mimeType) {
      const contentType = (res.headers && res.headers['content-type']) || ''
      if (contentType.includes('application/json')) {
        const text = await res.data.text()
        const err = JSON.parse(text)
        throw new Error(err.message || '下载失败')
      }
      const blob = new Blob([res.data], { type: mimeType })
      const filename = this.parseBlobFilename(res, defaultFilename)
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = filename
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)
      return filename
    },
    async batchDownloadQr() {
      if (this.batchQrDownloading || this.allQrDownloading || this.exporting || this.batchDeleting) return
      const ids = this.getSelectedIds()
      if (!ids.length) {
        this.$message.warning('所选记录无效')
        return
      }
      if (ids.length > 200) {
        this.$message.warning('单次最多下载 200 个二维码，请减少选择数量')
        return
      }
      this.batchQrDownloading = true
      this.progressDialogTitle = '正在批量下载二维码'
      this.progressDialogHint = `共 ${ids.length} 个二维码，正在打包为 ZIP…`
      this.exportProgressVisible = true
      this.exportProgressPercent = 0
      this.exportProgressText = '正在连接服务器…'
      this.startExportProgressSimulation()
      try {
        const res = await certBatchQrDownloadApi(ids, {
          onDownloadProgress: e => {
            if (e.total > 0) {
              const dl = Math.round((e.loaded / e.total) * 11)
              this.setExportProgress(88 + dl, '正在下载压缩包…')
            } else if (e.loaded > 0) {
              this.setExportProgress(90, '正在接收数据…')
            }
          }
        })
        this.stopExportProgressSimulation()
        this.setExportProgress(92, '正在保存文件…')
        await this.saveBlobResponse(
          res,
          `证书二维码_${new Date().toISOString().slice(0, 10)}.zip`,
          'application/zip'
        )
        this.setExportProgress(100, '下载完成')
        await this.exportDelay(450)
        this.$message.success(`已下载 ${ids.length} 个二维码`)
        this.clearTableSelection()
      } catch (e) {
        this.$message.error(e.message || '批量下载失败')
      } finally {
        this.stopExportProgressSimulation()
        this.exportProgressVisible = false
        this.batchQrDownloading = false
        this.exportProgressPercent = 0
        this.exportProgressText = ''
        this.progressDialogHint = ''
      }
    },
    async downloadAllQr() {
      if (this.allQrDownloading || this.batchQrDownloading || this.exporting || this.batchDeleting) return
      const count = this.total || 0
      if (count <= 0) {
        this.$message.warning('当前没有可下载的证书，请先查询')
        return
      }
      if (count > 5000) {
        this.$message.warning('单次最多下载 5000 个二维码，请缩小筛选范围')
        return
      }
      try {
        await this.$confirm(
          `将按当前筛选条件打包下载全部二维码（约 ${count} 个），数量较多时耗时较长，是否继续？`,
          '下载全部二维码',
          { type: 'info', confirmButtonText: '开始下载', cancelButtonText: '取消' }
        )
      } catch (e) {
        return
      }
      this.allQrDownloading = true
      this.progressDialogTitle = '正在下载全部二维码'
      this.progressDialogHint = `当前筛选约 ${count} 个二维码，正在打包为 ZIP…`
      this.exportProgressVisible = true
      this.exportProgressPercent = 0
      this.exportProgressText = '正在连接服务器…'
      this.startExportProgressSimulation()
      try {
        const res = await certDownloadAllQrApi(this.buildFilterParams(), {
          onDownloadProgress: e => {
            if (e.total > 0) {
              const dl = Math.round((e.loaded / e.total) * 11)
              this.setExportProgress(88 + dl, '正在下载压缩包…')
            } else if (e.loaded > 0) {
              this.setExportProgress(90, '正在接收数据…')
            }
          }
        })
        this.stopExportProgressSimulation()
        this.setExportProgress(92, '正在保存文件…')
        await this.saveBlobResponse(
          res,
          `证书二维码_全部_${new Date().toISOString().slice(0, 10)}.zip`,
          'application/zip'
        )
        this.setExportProgress(100, '下载完成')
        await this.exportDelay(450)
        this.$message.success('全部二维码已下载')
      } catch (e) {
        this.$message.error(e.message || '下载全部二维码失败')
      } finally {
        this.stopExportProgressSimulation()
        this.exportProgressVisible = false
        this.allQrDownloading = false
        this.exportProgressPercent = 0
        this.exportProgressText = ''
        this.progressDialogHint = ''
      }
    },
    async exportExcel() {
      if (this.exporting || this.batchQrDownloading || this.allQrDownloading) return
      this.exporting = true
      this.progressDialogTitle = '正在导出 Excel'
      this.progressDialogHint =
        this.total > 0
          ? `当前筛选约 ${this.total} 条记录，含二维码图片时生成时间较长，请耐心等待`
          : ''
      this.exportProgressVisible = true
      this.exportProgressPercent = 0
      this.exportProgressText = '正在连接服务器…'
      this.startExportProgressSimulation()
      try {
        const res = await certExportApi(this.buildFilterParams(), {
          onDownloadProgress: e => {
            if (e.total > 0) {
              const dl = Math.round((e.loaded / e.total) * 11)
              this.setExportProgress(88 + dl, '正在下载文件…')
            } else if (e.loaded > 0) {
              this.setExportProgress(90, '正在接收数据…')
            }
          }
        })
        this.stopExportProgressSimulation()
        this.setExportProgress(92, '正在解析文件…')
        this.setExportProgress(96, '正在保存到本地…')
        await this.saveBlobResponse(
          res,
          `证书列表_${new Date().toISOString().slice(0, 10)}.xlsx`,
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        )
        this.setExportProgress(100, '导出完成')
        await this.exportDelay(450)
        this.$message.success('导出成功')
      } catch (e) {
        this.$message.error(e.message || '导出失败')
      } finally {
        this.stopExportProgressSimulation()
        this.exportProgressVisible = false
        this.exporting = false
        this.exportProgressPercent = 0
        this.exportProgressText = ''
        this.progressDialogHint = ''
      }
    },
    handleSizeChange(val) {
      this.size = val
      this.page = 1
      this.fetchList()
    },
    openScanDialog(row) {
      this.scanRow = row
      this.scanMode = 'reset'
      const n = row.scanCount != null ? Number(row.scanCount) : 0
      this.scanCustomValue = Number.isFinite(n) ? n : 0
      this.scanDialogVisible = true
    },
    onScanDialogClosed() {
      this.scanRow = null
      this.scanMode = 'reset'
    },
    async confirmScan() {
      if (!this.scanRow) return
      let scanCount
      if (this.scanMode === 'reset') {
        scanCount = 0
      } else {
        const v = this.scanCustomValue
        if (v === null || v === undefined || Number(v) < 0) {
          this.$message.warning('请输入大于等于 0 的次数')
          return
        }
        scanCount = Number(v)
      }
      this.scanSaving = true
      try {
        await certUpdateScanCountApi(this.scanRow.id, { scanCount })
        this.$message.success('已更新查询次数')
        this.scanDialogVisible = false
        this.fetchList()
      } catch (e) {
        this.$message.error(e.message || '更新失败')
      } finally {
        this.scanSaving = false
      }
    },
    async fetchList() {
      this.loading = true
      try {
        const params = { page: this.page - 1, size: this.size }
        const q = (this.filterQueryCode || '').trim()
        if (q) params.queryCode = q
        const kw = (this.filterProductName || '').trim()
        if (kw) params.productName = kw
        if (this.filterAuditStatus) params.auditStatus = this.filterAuditStatus
        const res = await certPageApi(params)
        const d = res.data || {}
        this.list = d.content || []
        this.total = d.totalElements || 0
        this.prefetchQrThumbs(this.list)
        this.clearTableSelection()
      } catch (e) {
        this.$message.error(e.message || '加载失败')
      } finally {
        this.loading = false
      }
    },
    async prefetchQrThumbs(rows) {
      if (!rows || !rows.length) return
      for (const row of rows) {
        if (row.qrImageBase64) {
          this.applyQrFromRow(row)
        } else {
          await this.ensureQrThumb(row)
        }
      }
    },
    applyQrFromRow(row) {
      if (!row || !row.id || !row.queryCode || this.qrCache[row.id]) return
      if (row.qrImageBase64) {
        this.$set(this.qrCache, row.id, row.qrImageBase64)
      }
    },
    async ensureQrThumb(row) {
      if (!row || !row.id || !row.queryCode || this.qrCache[row.id]) return
      if (row.qrImageBase64) {
        this.$set(this.qrCache, row.id, row.qrImageBase64)
        return
      }
      try {
        const qr = await fetchCertQr({ id: row.id, size: 88 })
        this.$set(this.qrCache, row.id, qr.dataUrl)
        row.qrImageBase64 = qr.dataUrl
        row.qrQueryUrl = qr.queryUrl
      } catch (e) {
        console.warn('二维码加载失败', row.queryCode, e)
      }
    },
    async openQrDialog(row) {
      if (!row || !row.queryCode) return
      this.qrDialogRow = row
      this.qrDialogLink = row.qrQueryUrl || ''
      this.qrDialogDataUrl = row.qrImageBase64 || ''
      this.qrDialogVisible = true
      if (this.qrDialogDataUrl && this.qrDialogLink) return
      try {
        const qr = await fetchCertQr({
          id: row.id != null && String(row.id).match(/^\d+$/) ? row.id : undefined,
          queryCode: row.queryCode,
          size: 280
        })
        this.qrDialogLink = qr.queryUrl
        this.qrDialogDataUrl = qr.dataUrl
        row.qrQueryUrl = qr.queryUrl
        row.qrImageBase64 = qr.dataUrl
        if (row.id) {
          this.$set(this.qrCache, row.id, qr.dataUrl)
        }
      } catch (e) {
        this.$message.error(e.message || '二维码加载失败')
      }
    },
    onQrDialogClosed() {
      this.qrDialogRow = null
      this.qrDialogDataUrl = ''
      this.qrDialogLink = ''
    },
    copyQrLink() {
      if (!this.qrDialogLink) return
      const done = () => this.$message.success('链接已复制')
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(this.qrDialogLink).then(done).catch(() => {
          this.fallbackCopy(this.qrDialogLink)
        })
      } else {
        this.fallbackCopy(this.qrDialogLink)
      }
    },
    fallbackCopy(text) {
      const ta = document.createElement('textarea')
      ta.value = text
      ta.style.position = 'fixed'
      ta.style.left = '-9999px'
      document.body.appendChild(ta)
      ta.select()
      try {
        document.execCommand('copy')
        this.$message.success('链接已复制')
      } catch (e) {
        this.$message.warning('请手动复制链接')
      }
      document.body.removeChild(ta)
    },
    buildQrDownloadFilename(row) {
      if (!row) return 'cert-qr.png'
      const artist =
        String(row.artistName || '未知艺人')
          .trim()
          .replace(/[\\/:*?"<>|\s]+/g, '_') || '未知艺人'
      const code =
        String(row.queryCode || 'code')
          .trim()
          .replace(/[\\/:*?"<>|\s]+/g, '_') || 'code'
      return `cert-qr-${artist}-${code}.png`
    },
    downloadQrImage() {
      if (!this.qrDialogDataUrl || !this.qrDialogRow) return
      const a = document.createElement('a')
      a.href = this.qrDialogDataUrl
      a.download = this.buildQrDownloadFilename(this.qrDialogRow)
      a.click()
    },
    openCreate() {
      this.dialogTitle = '新建证书'
      this.form = emptyForm()
      this.loadArtistOptions()
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },
    openEdit(row) {
      this.dialogTitle = '编辑证书'
      this.loadArtistOptions()
      this.form = {
        id: row.id,
        queryCode: row.queryCode,
        orgName: row.orgName,
        artistId: row.artistId != null ? row.artistId : null,
        productName: row.productName,
        securityNo: row.securityNo,
        rating: row.rating || '',
        queryResultFirst: row.queryResultFirst || '',
        queryResultRepeat: row.queryResultRepeat || '',
        auditStatus: row.auditStatus || 'PASS'
      }
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },
    resetForm() {
      this.form = emptyForm()
    },
    submit() {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        this.saving = true
        try {
          const payload = { ...this.form }
          delete payload.id
          delete payload.artistName
          if (this.form.id) {
            await certUpdateApi(this.form.id, payload)
            this.$message.success('已保存')
          } else {
            await certCreateApi(payload)
            this.$message.success('已创建')
          }
          this.dialogVisible = false
          await this.fetchList()
        } catch (e) {
          this.$message.error(e.message || '保存失败')
        } finally {
          this.saving = false
        }
      })
    },
    remove(row) {
      this.$confirm(`确定删除查询码「${row.queryCode}」吗？`, '提示', {
        type: 'warning'
      })
        .then(async () => {
          await certDeleteApi(row.id)
          this.$message.success('已删除')
          this.fetchList()
        })
        .catch(() => {})
    },
    openImportDialog() {
      this.resetImportDialog()
      this.loadArtistOptions()
      this.importVisible = true
    },
    resetImportDialog() {
      this.importStep = 0
      this.importFileList = []
      this.importSelectedFile = null
      this.importParsing = false
      this.importConfirming = false
      this.importSkipDuplicates = true
      this.importPreview = { total: 0, validCount: 0, duplicateCount: 0, errorCount: 0 }
      this.importNewArtists = []
      this.importRows = []
      this.importConfirmResult = {
        total: 0,
        successCount: 0,
        skippedCount: 0,
        failedCount: 0,
        messages: [],
        details: []
      }
    },
    onImportFileChange(file, fileList) {
      this.importFileList = fileList.slice(-1)
      this.importSelectedFile = file && file.raw ? file.raw : null
    },
    onImportFileRemove() {
      this.importFileList = []
      this.importSelectedFile = null
    },
    async downloadImportTemplate() {
      this.importTemplateLoading = true
      try {
        const res = await certImportTemplateApi()
        const blob = new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = '证书导入模板.xlsx'
        a.click()
        window.URL.revokeObjectURL(url)
      } catch (e) {
        this.$message.error(e.message || '下载模板失败')
      } finally {
        this.importTemplateLoading = false
      }
    },
    async parseImportFile() {
      if (!this.importSelectedFile) {
        this.$message.warning('请先选择 Excel 文件')
        return
      }
      this.importParsing = true
      try {
        const res = await certImportPreviewApi(this.importSelectedFile)
        const data = res.data || {}
        this.importPreview = {
          total: data.total || 0,
          validCount: data.validCount || 0,
          duplicateCount: data.duplicateCount || 0,
          errorCount: data.errorCount || 0
        }
        this.importNewArtists = data.newArtists || []
        this.importRows = (data.rows || []).map(r => ({
          ...r,
          messages: r.messages || [],
          artistWillCreate: !!r.artistWillCreate
        }))
        if (this.importNewArtists.length) {
          this.$message.info(`检测到 ${this.importNewArtists.length} 位新艺人，确认导入时将自动建档`)
        }
        if (this.importPreview.duplicateCount > 0) {
          this.$message.warning(`检测到 ${this.importPreview.duplicateCount} 条重复数据，请复检后处理`)
        } else if (this.importPreview.errorCount > 0) {
          this.$message.warning(`有 ${this.importPreview.errorCount} 行存在错误，请在复检中修改`)
        } else if (!this.importNewArtists.length) {
          this.$message.success('解析成功，请复检后确认导入')
        }
        this.importStep = 1
      } catch (e) {
        this.$message.error(e.message || '解析失败')
      } finally {
        this.importParsing = false
      }
    },
    importRowClassName({ row }) {
      if (row.hasError) return 'import-row-error'
      if (row.duplicate) return 'import-row-dup'
      if (row.artistWillCreate) return 'import-row-new-artist'
      return ''
    },
    onImportArtistNameChange(row) {
      const name = (row.artistName || '').trim()
      row.artistName = name
      row.messages = (row.messages || []).filter(
        m => !String(m).includes('艺人') && !String(m).includes('名字')
      )
      if (!name) {
        row.hasError = true
        row.artistId = null
        row.artistWillCreate = false
        row.messages = [...row.messages, '名字不能为空']
        this.refreshImportPreviewCounts()
        return
      }
      const matched = (this.artistOptions || []).find(
        a => String(a.name || '').trim().toLowerCase() === name.toLowerCase()
      )
      if (matched) {
        row.artistId = matched.id
        row.artistWillCreate = false
        row.hasError = false
      } else {
        row.artistId = null
        row.artistWillCreate = true
        row.hasError = false
        row.messages = [...row.messages, `艺人「${name}」不在库中，确认导入时将自动新建`]
      }
      this.refreshImportPreviewCounts()
    },
    onImportArtistChange(row) {
      const a = (this.artistOptions || []).find(x => x.id === row.artistId)
      row.artistName = a ? a.name : row.artistName
      if (row.artistId) {
        row.hasError = false
        row.artistWillCreate = false
        row.messages = (row.messages || []).filter(m => !String(m).includes('艺人'))
      }
      this.refreshImportPreviewCounts()
    },
    recheckImportRowLocal(row) {
      const code = (row.queryCode || '').trim().toLowerCase()
      if (!code) {
        row.hasError = true
        if (!(row.messages || []).some(m => String(m).includes('查询码'))) {
          row.messages = [...(row.messages || []), '编号/查询码不能为空']
        }
      }
      // 表内重复本地复检
      const same = this.importRows.filter(
        r => (r.queryCode || '').trim().toLowerCase() === code && code
      )
      row.duplicate = same.length > 1
      if (row.duplicate) {
        if (!(row.messages || []).some(m => String(m).includes('表内'))) {
          row.messages = [...(row.messages || []), '与本次导入表内其他行的查询码/编号重复']
        }
      } else {
        row.messages = (row.messages || []).filter(m => !String(m).includes('表内'))
      }
      this.refreshImportPreviewCounts()
    },
    refreshImportPreviewCounts() {
      let valid = 0
      let dup = 0
      let err = 0
      const newArtistMap = {}
      this.importRows.forEach(r => {
        if (r.duplicate) dup++
        if (r.hasError) err++
        if (!r.duplicate && !r.hasError) valid++
        if (r.artistWillCreate && !r.hasError && (r.artistName || '').trim()) {
          const key = String(r.artistName).trim().toLowerCase()
          if (!newArtistMap[key]) newArtistMap[key] = String(r.artistName).trim()
        }
      })
      this.importNewArtists = Object.keys(newArtistMap).map(k => newArtistMap[k])
      this.importPreview = {
        total: this.importRows.length,
        validCount: valid,
        duplicateCount: dup,
        errorCount: err
      }
    },
    removeImportRow(index) {
      this.importRows.splice(index, 1)
      this.refreshImportPreviewCounts()
    },
    removeInvalidImportRows() {
      this.importRows = this.importRows.filter(r => !r.hasError && !r.duplicate)
      this.refreshImportPreviewCounts()
      this.$message.success('已移除无效/重复行')
    },
    async confirmImport() {
      if (!this.importRows.length) {
        this.$message.warning('没有可导入的数据')
        return
      }
      const validCount = this.importRows.filter(r => !r.hasError && !r.duplicate).length
      const dupCount = this.importRows.filter(r => r.duplicate).length
      const errCount = this.importRows.filter(r => r.hasError).length
      if (!this.importSkipDuplicates && dupCount > 0) {
        this.$message.error('仍有重复数据，请修改查询码或勾选「跳过重复行」')
        return
      }
      if (validCount === 0 && !(this.importSkipDuplicates && this.importRows.length)) {
        this.$message.error('没有可导入的有效数据，请先修正错误行')
        return
      }
      if (errCount > 0) {
        try {
          await this.$confirm(
            `仍有 ${errCount} 行错误数据将被标记失败，是否继续导入其余有效行？`,
            '提示',
            { type: 'warning' }
          )
        } catch (e) {
          return
        }
      }
      if (this.importNewArtists.length) {
        try {
          const names = this.importNewArtists.slice(0, 20).join('、')
          const more =
            this.importNewArtists.length > 20
              ? ` 等共 ${this.importNewArtists.length} 位`
              : `（共 ${this.importNewArtists.length} 位）`
          await this.$confirm(
            `以下艺人不在库中，确认后将自动新建：\n${names}${more}`,
            '将自动新建艺人',
            { type: 'info', confirmButtonText: '确认导入', cancelButtonText: '取消' }
          )
        } catch (e) {
          return
        }
      }
      this.importConfirming = true
      try {
        const payload = {
          skipDuplicates: this.importSkipDuplicates,
          rows: this.importRows.map(r => ({
            excelRow: r.excelRow,
            artistName: r.artistName,
            artistId: r.artistId,
            productName: r.productName,
            securityNo: r.securityNo,
            queryCode: r.queryCode,
            rating: r.rating,
            orgName: r.orgName || 'ACAA',
            queryResultFirst: r.queryResultFirst || '首次查询，本签名为亲笔签名。',
            queryResultRepeat: r.queryResultRepeat || '非首次查询，本签名为亲笔签名。',
            auditStatus: r.auditStatus || 'PASS'
          }))
        }
        const res = await certImportConfirmApi(payload)
        this.importConfirmResult = res.data || {}
        this.importStep = 2
        if ((this.importConfirmResult.successCount || 0) > 0) {
          this.$message.success('批量导入完成')
          this.loadArtistOptions()
        }
      } catch (e) {
        this.$message.error(e.message || '导入失败')
      } finally {
        this.importConfirming = false
      }
    },
    async closeImportAndRefresh() {
      this.importVisible = false
      await this.fetchList()
    }
  }
}
</script>

<style lang="scss" scoped>
.toolbar {
  margin-bottom: 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.toolbar-filter,
.toolbar-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.toolbar-filter {
  padding: 10px 12px;
  background: #f7f8fa;
  border: 1px solid #ebeef5;
  border-radius: 4px;
}

.toolbar-label {
  flex-shrink: 0;
  margin-right: 4px;
  font-size: 12px;
  font-weight: 600;
  color: #909399;
  letter-spacing: 0.04em;
}

.toolbar-filter-actions {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-left: 4px;
}

.toolbar-actions {
  justify-content: space-between;
  padding: 0 2px;
}

.toolbar-actions-left,
.toolbar-actions-right {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.toolbar-divider {
  display: inline-block;
  width: 1px;
  height: 16px;
  margin: 0 4px;
  background: #dcdfe6;
}

.toolbar-input {
  width: 200px;
}

.toolbar-query-code {
  width: 140px;
}

.toolbar-select {
  width: 120px;
}

.toolbar-selected-tip {
  font-size: 12px;
  color: #e6a23c;
  margin-right: 2px;

  &.is-muted {
    color: #c0c4cc;
  }
}

.pager {
  margin-top: 12px;
  text-align: right;
}

.export-progress-tip {
  margin: 0 0 16px;
  font-size: 14px;
  color: #303133;
  line-height: 1.5;
}

.export-progress-sub {
  margin: 14px 0 0;
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
}

.scan-dialog-body {
  .scan-tip {
    margin: 0 0 16px;
    font-size: 13px;
    color: #606266;
  }
  .scan-mode {
    display: block;
    margin-bottom: 12px;
  }
  .scan-custom {
    display: flex;
    align-items: center;
    gap: 12px;
    .label {
      width: 40px;
      font-size: 14px;
      color: #606266;
    }
  }
}

.qr-cell {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: background 0.15s;

  &:hover {
    background: #f5f7fa;
  }
}

.qr-thumb {
  width: 48px;
  height: 48px;
  display: block;
  object-fit: contain;
}

.qr-thumb-placeholder {
  font-size: 12px;
  color: #909399;
}

.qr-dialog-body {
  text-align: center;

  .qr-dialog-tip {
    margin: 0 0 16px;
    font-size: 13px;
    color: #606266;
    line-height: 1.5;
    text-align: left;
  }

  .qr-dialog-img-wrap {
    min-height: 280px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
  }

  .qr-dialog-img {
    width: 280px;
    height: 280px;
    object-fit: contain;
  }

  .qr-dialog-loading {
    font-size: 14px;
    color: #909399;
  }

  .qr-dialog-link {
    text-align: left;
  }
}

.import-dialog-title {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-right: 28px;
  line-height: 1.3;
}

.import-dialog-title-main {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.import-dialog-title-sub {
  font-size: 12px;
  font-weight: 400;
  color: #909399;
}

.import-steps {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0 22px;
  padding: 0 8px;
}

.import-step-item {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #c0c4cc;

  &.is-active {
    color: #409eff;

    .import-step-num {
      background: #409eff;
      color: #fff;
      border-color: #409eff;
    }
  }

  &.is-done {
    color: #67c23a;

    .import-step-num {
      background: #67c23a;
      color: #fff;
      border-color: #67c23a;
    }

    .import-step-line {
      background: #c2e7b0;
    }
  }
}

.import-step-num {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 1px solid #dcdfe6;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  line-height: 1;
  background: #fff;
  transition: all 0.2s ease;
}

.import-step-text {
  font-size: 13px;
}

.import-step-line {
  width: 48px;
  height: 1px;
  margin: 0 12px 0 4px;
  background: #e4e7ed;
}

.import-guide {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
  padding: 12px 14px;
  background: #f7f8fa;
  border-radius: 6px;

  p {
    margin: 0;
    flex: 1;
    font-size: 13px;
    color: #606266;
    line-height: 1.65;
  }

  em {
    font-style: normal;
    color: #303133;
    font-weight: 600;
  }
}

.import-template-btn {
  flex-shrink: 0;
  padding: 0;
  margin-top: 1px;
}

.import-uploader {
  ::v-deep .el-upload {
    width: 100%;
  }

  ::v-deep .el-upload-dragger {
    width: 100%;
    height: 180px;
    border-radius: 8px;
    border: 1px dashed #dcdfe6;
    background: #fafbfc;
    transition: border-color 0.2s, background 0.2s;

    &:hover {
      border-color: #409eff;
      background: #f5f9ff;
    }
  }

  ::v-deep .el-upload__tip {
    margin-top: 10px;
    text-align: center;
    color: #909399;
  }
}

.import-upload-icon {
  font-size: 36px;
  color: #c0c4cc;
  margin: 36px 0 12px;
  line-height: 1;
}

.import-summary {
  margin-bottom: 12px;
  padding: 10px 14px;
  border-radius: 6px;
  font-size: 13px;
  line-height: 1.5;

  &.is-ok {
    background: #f0f9eb;
    color: #67c23a;
  }

  &.is-warn {
    background: #fdf6ec;
    color: #e6a23c;
  }
}

.import-new-artists {
  margin-bottom: 12px;
  padding: 12px 14px;
  border-radius: 6px;
  background: #fdf6ec;
  border: 1px solid #f5dab1;
}

.import-new-artists-title {
  font-size: 13px;
  color: #b88230;
  line-height: 1.5;
  margin-bottom: 8px;

  i {
    margin-right: 4px;
  }
}

.import-new-artists-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.import-new-artist-tag {
  margin: 0;
}

.import-artist-cell {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.import-review-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px 16px;
  margin-bottom: 12px;
  padding: 0 2px;
}

.import-hint {
  font-size: 12px;
  color: #909399;
}

.import-table {
  border-radius: 4px;
  overflow: hidden;
}

::v-deep .import-row-error {
  background: #fef0f0 !important;
}

::v-deep .import-row-dup {
  background: #fdf6ec !important;
}

::v-deep .import-row-new-artist {
  background: #faf6ef !important;
}

.import-result-banner {
  text-align: center;
  padding: 28px 16px 20px;
  border-radius: 8px;
  background: #f7f8fa;

  i {
    font-size: 40px;
    line-height: 1;
  }

  h3 {
    margin: 12px 0 8px;
    font-size: 17px;
    font-weight: 600;
    color: #303133;
  }

  p {
    margin: 0;
    font-size: 13px;
    color: #909399;
    line-height: 1.6;
  }

  &.is-ok i {
    color: #67c23a;
  }

  &.is-warn i {
    color: #e6a23c;
  }
}

.import-dialog-footer {
  text-align: right;
}
</style>

<style lang="scss">
/* append-to-body 弹窗需非 scoped */
.import-dialog {
  border-radius: 10px;
  overflow: hidden;

  .el-dialog__header {
    padding: 18px 20px 12px;
    border-bottom: 1px solid #f0f2f5;
  }

  .el-dialog__body {
    padding: 20px 24px 8px;
  }

  .el-dialog__footer {
    padding: 12px 24px 18px;
    border-top: 1px solid #f0f2f5;
  }
}
</style>
